module.exports = function getResource(label, vars = []) {
    let resources = {
        completeStoreList: 'Liste complète des magasins',
        happeningAtSephora: 'En cours chez Sephora',
        findASephora: 'Trouver un Sephora',
        storeLocator: 'Trouver un magasin',
        storeLocations: 'Emplacements du magasin'
    };
    return resources[label];
};
